import { render, staticRenderFns } from "./resultPage.vue?vue&type=template&id=005d86f8&scoped=true&"
import script from "./resultPage.vue?vue&type=script&lang=ts&"
export * from "./resultPage.vue?vue&type=script&lang=ts&"
import style0 from "./resultPage.vue?vue&type=style&index=0&id=005d86f8&lang=less&scoped=true&"
import style1 from "./resultPage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d86f8",
  null
  
)

export default component.exports